import React from 'react';
import { MultiSelect } from 'components/form';
import { Controller, useForm } from 'react-hook-form';
import { vendorContactRoleHumanReadable } from 'utils';
import { Box, Button, Stack, FormHelperText } from '@mui/material';
import { TiersForm } from '../types';

interface Props {
  isLoading: boolean;
  defaultValues: TiersForm;
  onConfirm: (configuration: TiersForm) => Promise<void>;
}

export const Tiers = ({ isLoading, defaultValues, onConfirm }: Props) => {
  const { control, handleSubmit } = useForm<TiersForm>({ defaultValues });

  const options = Object.entries(vendorContactRoleHumanReadable).map(([value, label]) => ({ label, value }));

  return (
    <Box sx={{ display: 'grid', gridTemplateRows: '1fr auto', gap: '1rem', height: '100%' }}>
      <Stack gap="1rem">
        <Controller
          control={control}
          name="configurationTiersHiddenFor"
          render={({ field }) => (
            <Stack>
              <MultiSelect
                label="Hidden for:"
                options={options}
                formControlProps={{ variant: 'standard' }}
                {...field}
              />
              <FormHelperText>Internal Tiers Builder will be hidden for selected roles</FormHelperText>
            </Stack>
          )}
        />

        <Controller
          control={control}
          name="tiersResultsHiddenFor"
          render={({ field }) => (
            <Stack>
              <MultiSelect
                label="Hidden for:"
                options={options}
                formControlProps={{ variant: 'standard' }}
                {...field}
              />
              <FormHelperText>Internal Tiers Results will be hidden for selected roles</FormHelperText>
            </Stack>
          )}
        />
      </Stack>

      <Box>
        <Button loading={isLoading} variant="contained" onClick={handleSubmit(onConfirm)}>
          Save
        </Button>
      </Box>
    </Box>
  );
};
